import { createContext, useContext } from 'react';
import { tLayoutContext } from './Layout.types.ts';

const initialState: tLayoutContext = {
  sidebarOpen: false,
  openAvatarMenu: false,
  pageSectionPadding: '',
  setSidebarOpen: () => {},
  setOpenAvatarMenu: () => {},
  toggleSidebar: () => {},
  currentTheme: 'leadsales',
  setCurrentTheme: () => {},
  messageNotification: null,
  setMessageNotification: () => {},
};

export const LayoutContext = createContext(initialState);

export const useLayoutContext = (): tLayoutContext => useContext(LayoutContext);
